export default {
  report: `Report`,
  startups: `100 startups`,
  extraContent: `More content`,
  fintech: `Let’s Fintech`,
  downloadReport: `Download the Report`,
};
